var _path, _defs;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgFilterDivider(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 96,
    height: 16,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25 7h16l.414-.414 5.172-5.172L48 0l1.414 1.414 5.172 5.172L55 7h16v.5c.833 0 3.5-.5 4.5-2.5C76 6.5 78 7 79 7c1-.167 3.3-1.3 4.5-4.5C87 7 93 8 96 8c-3 0-9 1-12.5 5.5C82.3 10.3 80 9.167 79 9c-1 0-3 .5-3.5 2-1-2-3.667-2.5-4.5-2.5V9H55l-.414.414-5.172 5.172L48 16l-1.414-1.414-5.172-5.172L41 9H25v-.5c-.833 0-3.5.5-4.5 2.5C20 9.5 18 9 17 9c-1 .167-3.3 1.3-4.5 4.5C9 9 3 8 0 8c3 0 9-1 12.5-5.5C13.7 5.7 16 6.833 17 7c1 0 3-.5 3.5-2 1 2 3.667 2.5 4.5 2.5V7zm23 6.172L42.828 8 48 2.828 53.172 8 48 13.172zM48 5l-3 3 3 3 3-3-3-3z",
    fill: "url(#filterDivider_svg__paint0_linear_1886_9257)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "filterDivider_svg__paint0_linear_1886_9257",
    x1: 48,
    y1: -0.889,
    x2: 48,
    y2: 16.889,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff",
    stopOpacity: 0.3
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff",
    stopOpacity: 0.1
  })))));
}

export default SvgFilterDivider;